import React from 'react'
import './search.css'

const SearchComponent = ({searchInput, search, searchTram}) => {
  return (
    <div class="col-md-6 input-buscar">
    <input className='form-control' type='search' placeholder='Buscar ...' ref={searchInput} onChange={searchTram} value={search}/>
    </div>
  )
}

export default SearchComponent
